function Header() {
  return <h1 className="text-3xl font-bold text-[#1C5073] py-12">GRADENDÉ</h1>;
}

export default Header;
